let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2NbW4")).then(() => parcelRequire('6HtX7'));